module.exports = __webpack_public_path__ + "img/icon_map_62_off_011.17a8bc53.png";